<template>
  <card class="card padding-bottom-ml">
    <personal-progress
      :spent="spent"
      :challenge-goal="props.challengeGoal"
      :header="header"
      :disabled="disabled || !hasActiveCashflow"
    />
    <div v-if="!hasActiveCashflow">
      <div class="separator" />
      <div class="ri-body padding-vertical-ml">
        רוצה לעקוב אחרי ההוצאות שלך במהלך האתגר?
        <span class="ri-bold-body">מינוי לתזרים זה בדיוק הדבר בשבילך, החודש ראשון בחינם.</span>
      </div>
      <riseup-button
        variant="primary"
        size="slim"
        title="לתזרים שלי"
        :action="redirectToCashflow"
      />
    </div>
  </card>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import { useRiseupAccountStore } from '../../stores/riseupAccount';
import { useChallengeStore } from '../../stores/challenge';
import PersonalProgress from './PersonalProgress.vue';
import Segment from '../../Segment';
import config from '../../config';

interface Props {
  header: string
  spent: number,
  challengeGoal: number,
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const challengeStore = useChallengeStore();
const { challenge } = storeToRefs(challengeStore);
const riseupAccountStore = useRiseupAccountStore();
const { hasActiveCashflow } = storeToRefs(riseupAccountStore);

const redirectToCashflow = () => {
  Segment.trackUserInteraction('Challenge_dashboard_join_cf', {
    challengeId: challenge?.value?.challengeId,
  });
  window.location.href = `${config.get().cashflowPublicUrl}/introduction`;
};
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
.card {
  background-color: $riseup_white;
  color: $riseup_black;
}

.separator {
  border-bottom: 1px solid $riseup_gray_0;
}
</style>
